module.exports = __webpack_public_path__ + "img/图层 15.784acc53.png";